import * as React from 'react'

import createContext from 'modules/core/hooks/createContext'
import { useCallback } from 'modules/core/hooks/useCallback'

import type { ClipboardDispatch } from './reducers/clipboard'
import clipboardReducer, {
  ClipboardState,
  initialClipboardState,
} from './reducers/clipboard'

const { context: ClipboardStateContext, hook: useClipboardState } = createContext<ClipboardState>()
const { context: ClipboardDispatchContext, hook: useClipboardDispatch } =
  createContext<ClipboardDispatch>()

const ClipboardProvider = ({ children }: React.PropsWithChildren) => {
  const memoizedReducer = useCallback(clipboardReducer, [])
  const [state, dispatch] = React.useReducer(memoizedReducer, initialClipboardState())

  return (
    <ClipboardDispatchContext.Provider value={dispatch}>
      <ClipboardStateContext.Provider value={state}>{children}</ClipboardStateContext.Provider>
    </ClipboardDispatchContext.Provider>
  )
}

export { ClipboardProvider, useClipboardDispatch, useClipboardState }
